import { render, staticRenderFns } from "./prompt.vue?vue&type=template&id=5e0dde53"
import script from "./prompt.vue?vue&type=script&lang=js"
export * from "./prompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports